var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "moulding-results" } },
    [
      _vm.mouldings && _vm.mouldings.length > 0
        ? _c(
            "b-row",
            { staticClass: "grid" },
            _vm._l(_vm.mouldings, function (moulding, key) {
              return _c(
                "a",
                {
                  key: moulding.sku,
                  staticClass: "col-sm-6 col-xl-3",
                  attrs: { sm: "6", xl: "3" },
                },
                [
                  _c("moulding-result", {
                    attrs: {
                      moulding: moulding,
                      selected:
                        _vm.mouldingSelected &&
                        moulding.sku === _vm.mouldingSelected.sku,
                      "non-frame-price": _vm.nonFramePrice,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onSelect(moulding)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            0
          )
        : !_vm.loading
        ? _c("p", { staticClass: "lead text-center text-muted my-4" }, [
            _vm._v("No Results Found"),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }